import React from 'react'

const Social = () => {
  return (
    <div className='homeSocial'>
        <a href="https://wa.me/2348083783705?text=Hi,%20I%20want%20to%20make%20inquiries%20about" target='_blank' className="homeSocial-icon">
        <i class="uil uil-whatsapp"></i>
        </a>

        <a href="https://www.linkedin.com/in/olgacodes/" target='_blank' className="homeSocial-icon">
        <i class="uil uil-linkedin-alt"></i>
        </a>

        <a href="mailto:olgacodes@outlook.com?subject=Hello,%20Unique%20Olga&body=Hello%20there!" target='_blank' className="homeSocial-icon">
        <i class="uil uil-fast-mail"></i>
        </a>

        <a href="https://github.com/uniqueolgacodes" target='_blank' className="homeSocial-icon">
        <i class="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social